import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

/**
 * Dynamic Text Component
 * @extends {React.PureComponent}
 */
class TextComponent extends PureComponent {
  /** TextComponent props
   * @property {element|node} - component children
   * @property {string} [className] - modifier prop
   * @property {string} ['data-element-name'] - data-element-name
   * @property {function} [onClick] - onClick action
   * @property {Object} [style] - modifier prop
   * @property {string} [tag = 'div'] - component tag
   */
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
    className: PropTypes.string,
    'data-element-name': PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.string,
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p', 'em'])
  };

  /**
   * TextComponent default props
   * @property {string} [tag = 'div'] - component tag
   */
  static defaultProps = {
    tag: 'div'
  };

  /**
   * Returns a dynamic tag element
   * @returns {JSX}
   */
  render() {
    const {
      tag: Tag,
      children,
      className,
      style,
      onClick,
      'data-element-name': dataElementName
    } = this.props;

    return (
      <Tag
        className={className}
        style={style}
        onClick={onClick}
        data-element-name={dataElementName}
      >
        {children}
      </Tag>
    );
  }
}

export default TextComponent;
